import ReactDOM from 'react-dom';
import { useHistory } from 'react-router';
import useAuth from 'hooks/UseAuth';

import {
  Dispatch, SetStateAction, useRef, useState
} from 'react';
import { useOutside } from 'hooks/UseOutside';

import SuccessPentagon from '../../../../assets/img/success-pentagon.png';

import {
  ModalButton,
  ModalCloseButton, ModalContainer, ModalImage, ModalSection, ModalSubtitle, ModalTitle, ModalTitleHighlight
} from './_docsSubmitModal';

interface IDocsSubmitModalProps {
  toggleModal: Dispatch<SetStateAction<boolean>>;
  callback?: () => void;
}

export const DocsSubmitModal = ({
  toggleModal,
  callback
}: IDocsSubmitModalProps) => {
  const modalRoot = document.getElementById('root-modal');
  const modalRef = useRef(null);

  const { setUser } = useAuth();
  const history = useHistory()

  const [hideModal, setHideModal] = useState(false);

  const handleCloseModal = () => {
    setHideModal((prevState) => !prevState);

    setTimeout(() => {
      toggleModal((prevState) => !prevState);

      setUser(prevState => ({
        ...prevState,
        documents_status: 1
      }))

      history.push('/')
    }, 500);
  }

  useOutside(modalRef, handleCloseModal);

  if(!modalRoot) {
    return null;
  }

   return ReactDOM.createPortal(
     <ModalSection className={`${hideModal ? 'modal-docs-submit--hide' : ''}`}>
      <ModalContainer ref={modalRef}>
        <ModalCloseButton
          type="button"
          onClick={handleCloseModal}
        >
          X
        </ ModalCloseButton>
        <ModalTitle>
          <ModalTitleHighlight>
            Parabéns!
          </ModalTitleHighlight>
          <br />
          Sua documentação foi enviada com sucesso!
        </ModalTitle>
        <ModalSubtitle>
          Estamos analisando seus documentos, fique atento ao app para saber quando foi aprovado!
        </ModalSubtitle>
        <ModalImage src={SuccessPentagon} alt="documents submitted" />
        <ModalButton type="button" onClick={handleCloseModal}>
          ok, vamos lá!
        </ModalButton>
      </ModalContainer>
     </ModalSection>
     ,modalRoot
   )
}
